import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface StrategyFunctionDialogData {
  /** Display name of the strategy (e.g. "aggregateByCategoryWithoutSeries"). */
  strategyName: string;
  /** The full `function (...) { ... }` source as returned by
   *  `StrategyService.getStrategyFunctionString`. */
  func: string;
}

/**
 * Read-only modal that shows the source of a dashboard strategy function.
 *
 * Migrated from the legacy AngularJS `view-strategy-function-tpl.html` +
 * inline `strategyFunctionModalCtrl`. Opened from the "i" icon next to the
 * Strategy dropdown in `EditComponentDialogComponent`.
 */
@Component({
    selector: 'gtw-strategy-function-dialog',
    templateUrl: './strategy-function-dialog.component.html',
    styleUrls: ['./strategy-function-dialog.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class StrategyFunctionDialogComponent {
  minimise = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: StrategyFunctionDialogData,
    private dialogRef: MatDialogRef<StrategyFunctionDialogComponent>,
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }
}
